module.exports = __webpack_public_path__ + "3f3ac8dde4b1556e26a976ea235def77.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cos/0C00000P21.png
// module id = 1620
// module chunks = 0